<template>
  <div>
    <div class="ibox animated fadeInRightBig">
      <div class="ibox-title" style="padding:16px;">
        <h3>
          {{crudName}}
          <router-link
            :to="endPoint + 'add'"
            class="btn btn-primary"
            v-show="enableAdd"
            style="float:right;margin-top:-5px;"
          >{{newText}}</router-link>
        </h3>
      </div>
      <div class="ibox-content">
        <div class="block m-b-md text-right" v-if="enableAddModal">
          <button type="button" class="btn btn-success" @click="addModal">Adicionar {{ crudName }}</button>
        </div>
        <div class="block m-b-md text-left" style="margin-top: -15px" v-if="enableExtract">
          <button type="button" class="btn" @click="extract" style="position:absolute ; margin-top:20px ;font-weight:bold;background-color:#4cbb17; color:white"> 
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>  Extrair dados
          </button>
        </div>
        <v-server-table
          ref="table"
          :tableData="tableData"
          :name="table"
          :url="url"
          :columns="columns"
          :options="options"
        >
          <div slot="actions" slot-scope="props">
            <a
              v-show="enableDownload"
              data-toggle="tooltip"
              title="Download"
              class="btn btn-info fa fa-download"
              @click="download(props.row.file ? props.row.file : props.row.document)"
            ></a>
            <a
              v-show="enableView"
              data-toggle="tooltip"
              title="Consultar"
              class="btn btn-info fa fa-eye"
              @click="view(props.row.id)"
            ></a>
            <a
              v-show="enableEdit"
              data-toggle="tooltip"
              title="Editar"
              class="btn btn-warning fa fa-pencil"
              @click="edit(props.row.id)"
            ></a>
            <a
              v-show="enableEditModal"
              @click="editModal(props.row.id)"
              data-toggle="tooltip"
              title="Editar"
              class="btn btn-warning fa fa-pencil"
            ></a>
            <a
              v-show="enableDelete"
              data-toggle="tooltip"
              title="Deletar"
              class="btn btn-danger fa fa-trash"
              @click="destroy(props, props.row, props.index)"
              v-if="showDelete(props)"
            ></a>

            <template v-for="extra in extra">
              <a
                data-toggle="tooltip"
                :style="extra.style"
                :title="extra.title"
                :key="extra.id"
                :class="extra.class"
                @click="callExtra(extra.name, props, props.row, props.index)"
                v-if="showExtra(props, extra)"
              >{{extra.label}}</a>
            </template>
          </div>
          <div slot="photo" slot-scope="props">
            <img :src="props.row.photo" alt width="85px" />
          </div>
          <div slot="summary" slot-scope="props">{{ props.row.summary.substr(0, 100) + '...' }}</div>
          <div slot="document" slot-scope="props">
            <span v-if="!props.row.document">Documento não cadastrado!</span>
            <a
              :href="props.row.document"
              v-if="props.row.document"
              data-toggle="tooltip"
              target="_blank"
              title="Documento"
              class="btn btn-default fa fa-download"
            />
          </div>
          <div slot="question" slot-scope="props">
            <span v-if="!props.row.question">Perguntas não cadastradas!</span>
            <a
              :href="props.row.question"
              v-if="props.row.question"
              data-toggle="tooltip"
              target="_blank"
              title="Perguntas"
              class="btn btn-default fa fa-download"
            />
          </div>
          <div slot="color" slot-scope="props">
            <div class="box" v-bind:style="{ 'background-color': props.row.color }"></div>
            <span class="bold">{{ props.row.color }}</span>
          </div>
          <div slot="qrcode" slot-scope="props">
            <img :src="props.row.qrcode" alt class="qrcode" />
            <br />
            <span class="bold">{{ props.row.qrcode_name }}</span>
          </div>
          <div slot="qrcodevue" slot-scope="props">
            <qrcode-vue class="code" :value="props.row.registry" level="H"></qrcode-vue>
            <br />
            <span class="bold">{{ props.row.registry }}</span>
          </div>
        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import QrcodeVue from "qrcode.vue";

export default {
  data: function() {
    return {
      records: [],
      pages: [],
      tableData: []
    };
  },
  props: {
    crudName: String,
    newText: String,
    table: String,
    columns: Array,
    options: Object,
    endPoint: String,
    with: String,
    enableAdd: Boolean,
    enableAddModal: Boolean,
    enableExtract: Boolean,
    enableEditModal: Boolean,
    enableEdit: Boolean,
    enableDelete: Boolean,
    enableView: Boolean,
    enableDownload: Boolean,
    extra: Array
  },
  mounted() {
    this.enableExtract = this.enableExtract || false;
    this.enableAddModal = this.enableAddModal || false;
    this.enableEditModal = this.enableEditModal || false;
  },
  computed: {
    url() {
      return (
        this.$store.getters.api + this.endPoint + (this.with ? this.with : "")
      );
    }
  },
  methods: {
    extract(){
      const self = this;
      const api = self.$store.state.api + self.endPoint + 'extract';
      self.$http
          .get(api)
          .then(response => {
              window.open(
                  self.$store.getters.url +
                      "downloadExtractByHash/" + self.endPoint +
                      response.data,
                  "_blank"
              );
          })
          .catch(error => {
              self.$message("Erro", error.response.data, "error");
          });
    },
    callExtra(name, props, row, index) {
      this.$emit(name, {
        props,
        row,
        index
      });
    },
    edit(id) {
      this.$router.push({
        path: this.endPoint + "edit/" + id
      });
    },
    view(id) {
      this.$router.push({
        path: this.endPoint + "view/" + id
      });
    },
    download(file) {
      window.open(file, "_blank");
    },
    destroy(props, row, index) {
      const self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger"
          },
          confirm: {
            text: "Sim",
            value: "confirm"
          }
        }
      }).then(value => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;

          case "confirm":
            self.$http
              .delete(this.url + row.id, {
                id: row.id
              })
              .then(response => {
                self.$refs.table.tableData.splice(index - 1, 1);
                swal("Sucesso", "Registro excluído com sucesso!", "success");
              })
              .catch(errors => {
                let error = errors.response ? errors.response.data : errors;
                swal("Erro", error, "error");
              });
            break;
        }
      });
    },
    addModal: function() {
      this.$emit("addModal");
    },
    editModal: function(id) {
      this.$emit("editModal", id);
    },
    showDelete(props){
        if(props.row.status_id == 3){
          return false
        }
        return true
    },
    showExtra(props, extra){
        if(extra.name == 'modalImage' && props.row.status == 0 || props.row.signatureType == 'QrCode'){
            return false
        }

        return true
    }

  },
  components: {
    Pagination,
    QrcodeVue
  }
};
</script>

<style scoped>
.photo {
  max-height: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/Base/BaseCrud.vue